import React from 'react';
import PropTypes from 'prop-types';

function Undo({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M16.250986,20.2239479 C19.2489389,17.3230079 19.7365159,14.0801185 17.7137169,10.4952797 C16.3789409,8.12976676 13.8894577,6.96494132 10.2452674,7.00080334 L5,8.10383069" />
      <polyline points="8.26408658 2.93570102 4.90536888 8.21861422 10.2474005 11.5261856" />
    </svg>
  );
}

Undo.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Undo;
